<div class="canvas-inner-container">
    <div class="section-container">
        <section>
        <div class="text">A <span class="kn-bold"> Split Button </span> is a dual-function menu button that offers a default action as well as the possibility of choosing a different action by selecting from a set of alternatives.</div>
        </section>
       
        <section>
            <div class="kn-headline-24-med">Types</div>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_01.png">
        
        <section>
            <div class="text"><span class="kn-bold">1.	Primary</span></div>
            <div class="text"><span class="kn-bold">2.	Secondary</span></div>
            <div class="text"><span class="kn-bold">3.	Tertiary</span></div>
        </section>

        <section>
            <div class="kn-headline-24-med">States</div>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_02.png">

        <section>
            <div class="text"><span class="kn-bold">1.	Enabled</span></div>
            <div class="text"><span class="kn-bold">2.	Disabled</span></div>
            <div class="text"><span class="kn-bold">3.	Hover</span></div>
            <div class="text"><span class="kn-bold">4.	Focused</span></div>
            <div class="text"><span class="kn-bold">5.	Pressed</span></div>
        </section>
      
        <section>
            <div class="kn-headline-24-med">Anatomy</div>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_03a.png">

        <section>
            <section>
                <div class="kn-subtitle-16">Enabled button</div>      
            </section>

            <section>
                <div class="text"><span class="kn-bold">A.	Text label </span></div>
                <div class="text"><span class="kn-bold">B.	Container </span></div>
                <div class="text"><span class="kn-bold">C.	Leading icon </span></div>
                <div class="text"><span class="kn-bold">D.	Divider line </span></div>
                <div class="text"><span class="kn-bold">E.	Dropdown trailing icon </span></div>
            </section>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_03b.png">

        <section>
            <section>
                <div class="kn-subtitle-16">Main focused</div>      
            </section>

            <section>
                <div class="kn-subtitle-16">Menu focused</div>      
            </section>
   
            <section>
                <div class="text"><span class="kn-bold">F.	Dropdown trailing icon: </span>When the menu is displayed, the trailing icon switches between the downward-facing chevron to the upward-facing chevron.</div>
            </section>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_03c.png">

        <section>
            <section>
                <div class="kn-subtitle-16">Menu</div>      
            </section>

            <section>
                <div class="text"><span class="kn-bold">G.	Menu option: </span>A choice for the user, shown amongst other choices in a menu.</div>
                <div class="text"><span class="kn-bold">H.	Menu option hover </span></div>
            </section>
        </section>

        <section>
            <div class="kn-headline-24-med">Guidelines</div>
        </section>

        <section>
            <div class="kn-subtitle-16">Multiple related actions</div>
            <div class="text"> Use the split button when multiple related action options exist for a specific function (ex. "Export" as XLS, CSV, or XML).</div>

        </section>

        <section>        
            <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_04.png">

            <section>
                <div class="kn-subtitle-16">Button width</div>
            </section>

            <div class="text">Button width is variable based on the length of the label (with or without an icon) with the following guidelines:</div>
        
            <ul class="bullets">
                <li>Regardless of how few characters are used in the button label, minimum button width is 132px.</li>
                <li>Button width scales with the length of the button label, retaining a consistent 16px padding with the vertical boundaries of the button.</li>
            </ul>
        </section>

        <section>
            <div class="text"><span class="kn-bold">1.	Minimum width button: </span> In the case of minimum width buttons, the text label and optional leading icon are left-aligned while the dropdown trailing icon is right-aligned. </div>
            <div class="text"><span class="kn-bold">2.	Button beyond minimum width: </span> For text labels displaying beyond the set minimum width, the button retains the consistent 8px between button elements.</div>
        </section>

        <section>
            <div class="kn-subtitle-16">Label</div>
        
            <ul class="bullets">
                <li>Use the split button label to explain the purpose of the trigger invoked by clicking or tapping the button and indicating what will happen (ex. Download, Sign Up).</li>
                <li>Labels should be single words or succinct phrases that do not exceed 25-characters to support quick scanning and interpretation.</li>
                <li>Don't use punctuation marks such as periods or exclamation points.</li>
                <li>Button label text should always be uppercase.</li>
            </ul>
        </section>

        <section>
            <div class="kn-subtitle-16">Icons</div>
            <div class="text">Icons may be used in combination with text labels within split buttons to further reinforce the purpose of the button and the action triggered by interacting with it.</div>
            
            <ul class="bullets">
                <li>Keep the button text concise: 1 or 2 words., with fewer than 25 characters including spaces.</li>
                <li>Don't use punctuation marks such as periods or exclamation points.</li>
                <li>Use action words for the label that indicate what will happen (for example, Download or Sign Up).</li>
                <li>Use an icon and text where appropriate to reinforce actions.</li>
                <li>Button text should always be in uppercase.</li>
            </ul>
        </section>

        <section>
            <div class="kn-subtitle-16">Menu</div>
            <div class="text">Reference the Contextual Menu component for complete usage guidelines. See: Components – Navigation – Contextual Menu.</div>
        </section>

        <section>
            <div class="kn-headline-24-med">Avoid</div>
        </section>

        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_05.png">

        <section>
            <div class="kn-subtitle-16">Use for navigation</div>

            <div class="text">The split button is reserved for performing a specific function and should not be utilized as a mechanism for navigating to an alternate feature area of the application experience.</div>
        </section>


        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_06.png">
        
        <section>
            <div class="kn-subtitle-16">Custom button colors</div>

            <div class="text">Align with the standard button styling guidelines when displaying the split button in the application UI. Avoid introducing alternate button colors that may confuse the application User and increase their cognitive load in assigning meaning to the new color value.</div>
        </section>


        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_07.png">

        <section>
            <div class="kn-subtitle-16">Wrapping labels</div>

            <div class="text">Labels displayed within the presentation of split buttons should be limited to a single line and not be allowed to wrap to a second line of text.</div>
        </section>


        <img class="kn-responsive-img" src="assets/usage guidelines/split-button/KrakenDSM_Components_SplitButton_08.png">

        <section>
            <div class="kn-subtitle-16">Icons that do not reinforce action</div>

            <div class="text">Only use an icon within a split button if it substantially reinforces the explanation of the purpose of the trigger invoked by clicking or tapping the button, and if the inclusion of the icon is proven (through user testing) to draw necessary attention of the user to the presence of the action button in the interface layout. Avoid the use of icons in split buttons for merely aesthetic purposes and icons that do not intuitively reinforce the action of the button. Never use more than a single icon within a split button.</div>
        </section>

    </div>
</div>
